module.exports = __webpack_public_path__ + "static/AirTestIcon-6d3f4e50f885190a168bf03c1fd3f35b.png";